import { useQuery } from 'hooks/useCustomQuery';
import getVoicePolicy from 'API/VoicePolicies/getVoicePolicy';

const useGetVoicePolicy = (voicePolicyId, enabled = true) => {
    return useQuery({
        queryKey: ['VoicePolicy', voicePolicyId],
        queryFn: async () => {
            const response = await getVoicePolicy(voicePolicyId);
            return response.data;
        },
        enabled: enabled && !!voicePolicyId,
        staleTime: 5 * 60 * 1000,
        retry: false,
        refetchOnWindowFocus: false,
    });
};

export default useGetVoicePolicy;
